/*
 * OfferDetails Messages
 *
 * This contains all the text for the OfferDetails container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.OfferDetails';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Dettagli Offerta Noleggio',
  },
  button: {
    id: `${scope}.button`,
    defaultMessage: 'Personalizza Offerta',
  },
  duration: {
    id: `${scope}.duration`,
    defaultMessage: 'Durata',
  },
  deposit: {
    id: `${scope}.deposit`,
    defaultMessage: 'Anticipo',
  },
  distance: {
    id: `${scope}.distance`,
    defaultMessage: 'Km/Anno',
  },
  changeOfferTitle: {
    id: `${scope}.changeOfferTitle`,
    defaultMessage: "Selezione le caratteristiche dell'offerta",
  },
  changeDuration: {
    id: `${scope}.changeDuration`,
    defaultMessage: 'Seleziona la durata',
  },
  changeDeposit: {
    id: `${scope}.changeDeposit`,
    defaultMessage: "Seleziona l'anticipo",
  },
  changeDistance: {
    id: `${scope}.changeDistance`,
    defaultMessage: 'Seleziona una distanza',
  },
  action: {
    id: `${scope}.action`,
    defaultMessage: 'Salva le caratteristiche selezionate',
  },
});
